var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/* eslint-disable no-constant-condition */
import analytics from './analytics';
import { VoteType, } from './chatTypes';
var CHAT_URL = 'https://qaa.priceline.com/genai-svc/genai/chat/st/travelChat';
var JSON_START_DELIMITER = 'jsonstart';
var JSON_END_DELIMITER = 'jsonend';
var CHUNK_DELIMITER = '\r\r\n';
/**
 * fetchChatStream
 * fetch module to handle stream response from openai api
 * @public
 */
export var fetchChatStream = function (_a) {
    var submitChatMessagesPayload = _a.submitChatMessagesPayload, url = _a.url, 
    // Speech Controls
    includeSpeech = _a.includeSpeech, speechFetcher = _a.speechFetcher, sentenceArrayBuilder = _a.sentenceArrayBuilder, 
    // End Speech Controls
    headers = _a.headers, setStreamingText = _a.setStreamingText, handleJSON = _a.handleJSON;
    return __awaiter(void 0, void 0, void 0, function () {
        var blob, compressionEnabled, stream, compressedReadableStream, compressedResponse, abortController_1, timeoutId, res, reader, hasJson, finalJson, timer, result, response, textRes, textArray, text, sentences, audioReadyStrings, err_1, err_2;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 15, , 16]);
                    blob = void 0;
                    compressionEnabled = 'CompressionStream' in self;
                    if (!compressionEnabled) return [3 /*break*/, 3];
                    stream = new Blob([JSON.stringify(submitChatMessagesPayload)], {
                        type: 'application/json',
                    }).stream();
                    compressedReadableStream = stream.pipeThrough(new CompressionStream('gzip'));
                    return [4 /*yield*/, new Response(compressedReadableStream)];
                case 1:
                    compressedResponse = _c.sent();
                    return [4 /*yield*/, compressedResponse.blob()];
                case 2:
                    blob = _c.sent();
                    _c.label = 3;
                case 3:
                    abortController_1 = new AbortController();
                    timeoutId = setTimeout(function () {
                        abortController_1.abort();
                    }, 30000) // 30 seconds timeout for fetch request
                    ;
                    return [4 /*yield*/, fetch(url || CHAT_URL, {
                            method: 'POST',
                            body: compressionEnabled ? blob : JSON.stringify(submitChatMessagesPayload),
                            headers: __assign(__assign({ 'Content-Type': 'application/json', 'Cache-Control': 'no-cache' }, headers), { 'Content-Encoding': compressionEnabled ? 'gzip' : 'identity' }),
                            signal: abortController_1.signal,
                        })];
                case 4:
                    res = _c.sent();
                    clearTimeout(timeoutId);
                    if (res.status !== 200) {
                        throw Error("".concat(res.status, ": ").concat(res.statusText));
                    }
                    if (!(res.body && res.body.getReader)) return [3 /*break*/, 13];
                    reader = res.body.getReader();
                    hasJson = false;
                    finalJson = '';
                    timer = void 0;
                    _c.label = 5;
                case 5:
                    if (!true) return [3 /*break*/, 12];
                    _c.label = 6;
                case 6:
                    _c.trys.push([6, 10, , 11]);
                    return [4 /*yield*/, reader.read()];
                case 7:
                    result = _c.sent();
                    if (result === null || result === void 0 ? void 0 : result.done) {
                        if (timer) {
                            clearTimeout(timer);
                        }
                        setStreamingText('STREAMING_ENDED');
                        return [2 /*return*/, {
                                isOk: true,
                            }];
                    }
                    if (!(result === null || result === void 0 ? void 0 : result.value)) return [3 /*break*/, 9];
                    if (timer) {
                        clearTimeout(timer);
                    }
                    timer = setTimeout(function () {
                        abortController_1.abort();
                    }, 1000 * 20); // waiting for next chunk for 20s, if not received, abort request
                    response = new Response(result.value);
                    return [4 /*yield*/, response.text()];
                case 8:
                    textRes = _c.sent();
                    textArray = textRes.split(CHUNK_DELIMITER);
                    while (textArray.length > 0) {
                        text = ((_b = textArray.shift()) === null || _b === void 0 ? void 0 : _b.replace(/\0/g, '')) || '';
                        if (text === JSON_START_DELIMITER) {
                            hasJson = true;
                        }
                        else if (text === JSON_END_DELIMITER) {
                            hasJson = false;
                            handleJSON(finalJson);
                            finalJson = '';
                        }
                        else if (hasJson) {
                            finalJson += text;
                            if (includeSpeech && sentenceArrayBuilder) {
                                sentenceArrayBuilder.addMarkerChunk(finalJson);
                            }
                        }
                        else {
                            setStreamingText(text);
                            if (includeSpeech && sentenceArrayBuilder) {
                                sentenceArrayBuilder.addChunk(text.replace(/\0/g, ''));
                            }
                        }
                    }
                    if (includeSpeech && sentenceArrayBuilder && speechFetcher) {
                        sentences = sentenceArrayBuilder.getSentenceQueue();
                        if (sentences.length > 0) {
                            if (!speechFetcher.isPlaying || sentences.length >= 1) {
                                audioReadyStrings = sentenceArrayBuilder.dequeueAllSentences();
                                speechFetcher.addToQueue(audioReadyStrings);
                            }
                        }
                    }
                    _c.label = 9;
                case 9: return [3 /*break*/, 11];
                case 10:
                    err_1 = _c.sent();
                    return [2 /*return*/, {
                            isOk: false,
                            errorCode: 'READER_READ_ERROR',
                            errorMessage: err_1 === null || err_1 === void 0 ? void 0 : err_1.message,
                        }];
                case 11: return [3 /*break*/, 5];
                case 12: return [3 /*break*/, 14];
                case 13: return [2 /*return*/, {
                        isOk: false,
                        errorCode: 'NOT_SUPPORTED',
                        errorMessage: 'ReadableStream not supported',
                    }];
                case 14: return [3 /*break*/, 16];
                case 15:
                    err_2 = _c.sent();
                    setStreamingText('STREAMING_ENDED');
                    return [2 /*return*/, {
                            isOk: false,
                            errorCode: 'ERROR',
                            errorMessage: err_2 === null || err_2 === void 0 ? void 0 : err_2.message,
                        }];
                case 16: return [2 /*return*/];
            }
        });
    });
};
/**
 * submitChatMessages
 * post give message
 * @public
 */
export var submitChatMessages = function (_a) {
    var handleMarkerResponse = _a.handleMarkerResponse, submitChatMessagesPayload = _a.submitChatMessagesPayload, 
    // Local state control
    chatMessages = _a.chatMessages, 
    // Speech control
    includeSpeech = _a.includeSpeech, speechFetcher = _a.speechFetcher, sentenceArrayBuilder = _a.sentenceArrayBuilder, pushPrompt = _a.pushPrompt, 
    // End Speech Controls
    setChatMessage = _a.setChatMessage, setPrompts = _a.setPrompts, setStreamingText = _a.setStreamingText, setLoadingStatus = _a.setLoadingStatus, setErrorMessage = _a.setErrorMessage, setIsDisablingInputValue = _a.setIsDisablingInputValue, setOpenErrorComponent = _a.setOpenErrorComponent, 
    // Cache control
    _b = _a.cacheControl, setCachedMessages = _b.setCachedMessages, setCachedPrompts = _b.setCachedPrompts, 
    // Request options
    _c = _a.requestOptions, _d = _c.url, url = _d === void 0 ? '' : _d, _e = _c.headers, headers = _e === void 0 ? {} : _e, markerComponents = _a.markerComponents;
    return __awaiter(void 0, void 0, void 0, function () {
        var fullTexts, JSONResponses, result, date, chatMsgs_1, promptMsgs_1, finalTexts, promptMsg, chatMsg;
        var _f;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    setLoadingStatus(true); // display loading
                    setErrorMessage(''); // remove error message
                    fullTexts = [];
                    JSONResponses = [];
                    return [4 /*yield*/, fetchChatStream({
                            submitChatMessagesPayload: submitChatMessagesPayload,
                            url: url,
                            includeSpeech: includeSpeech,
                            speechFetcher: speechFetcher,
                            sentenceArrayBuilder: sentenceArrayBuilder,
                            headers: headers,
                            handleJSON: function (jsonstring) {
                                var parsedJson = JSON.parse(jsonstring);
                                JSONResponses.push(parsedJson);
                            },
                            setStreamingText: function (text) {
                                if (text !== 'STREAMING_ENDED') {
                                    fullTexts.push(text);
                                    var fullText = fullTexts.join('');
                                    // Display streaming text
                                    setStreamingText(fullText);
                                }
                                else {
                                    // Clear live streaming text, when streaming ends
                                    setStreamingText('');
                                }
                            },
                        })
                        // display the final full texts
                    ];
                case 1:
                    result = _g.sent();
                    // display the final full texts
                    if ((result === null || result === void 0 ? void 0 : result.isOk) && fullTexts.length !== 0) {
                        date = new Date();
                        chatMsgs_1 = [];
                        promptMsgs_1 = [];
                        finalTexts = fullTexts.join('').trim();
                        if (finalTexts.toLowerCase().startsWith('system error')) {
                            setIsDisablingInputValue(true);
                        }
                        if (finalTexts.length) {
                            promptMsg = {
                                role: 'assistant',
                                content: finalTexts,
                            };
                            promptMsgs_1.push(promptMsg);
                            setCachedPrompts(promptMsg);
                            chatMsg = __assign(__assign({}, promptMsg), { date: date, vote: VoteType.NONE });
                            chatMsgs_1.push(chatMsg);
                            setCachedMessages(chatMsg);
                        }
                        // Display the Marker component
                        if (JSONResponses.length > 0) {
                            JSONResponses.forEach(function (jsonResponse) {
                                var displayComponentName = jsonResponse.displayComponentName, textContent = jsonResponse.content, componentProps = jsonResponse.componentProps, assistantPromptMessage = jsonResponse.assistantPromptMessage;
                                if (typeof handleMarkerResponse === 'function' && (markerComponents === null || markerComponents === void 0 ? void 0 : markerComponents[displayComponentName])) {
                                    var _a = handleMarkerResponse(undefined, displayComponentName, textContent, componentProps), _b = _a.role, role = _b === void 0 ? 'assistant' : _b, _c = _a.content, content = _c === void 0 ? displayComponentName : _c, _d = _a.messageContent, messageContent = _d === void 0 ? '' : _d, _e = _a.promptContent, promptContent = _e === void 0 ? '' : _e, _f = _a.markerComponentProps, markerComponentProps = _f === void 0 ? {} : _f;
                                    var date_1 = new Date();
                                    // Text content Message
                                    if (messageContent || (content && content !== displayComponentName)) {
                                        var chatMessage_1 = {
                                            role: role,
                                            content: messageContent || content,
                                            date: date_1,
                                            vote: VoteType.NONE,
                                        };
                                        // Display Text content Message
                                        chatMsgs_1.push(chatMessage_1);
                                        setCachedMessages(chatMessage_1);
                                    }
                                    // Marker component Message
                                    var chatMessage = {
                                        role: role,
                                        content: '',
                                        displayComponentName: displayComponentName,
                                        markerComponentProps: __assign(__assign({}, componentProps), markerComponentProps),
                                        date: date_1,
                                        vote: VoteType.NONE,
                                    };
                                    // Display Marker component Message
                                    chatMsgs_1.push(chatMessage);
                                    setCachedMessages(chatMessage);
                                    // Save promptContent from the handleMarkerResponse
                                    if (promptContent || content) {
                                        var promptMessage = { role: role, content: promptContent || content };
                                        promptMsgs_1.push(promptMessage);
                                        setCachedPrompts(promptMessage);
                                    }
                                }
                                else {
                                    var date_2 = new Date();
                                    // Default Mark component message, like QUICK_ACTIONS
                                    var componentMessage = {
                                        role: '',
                                        content: '',
                                        displayComponentName: displayComponentName,
                                        markerComponentProps: __assign({}, componentProps),
                                        date: date_2,
                                        vote: VoteType.NONE,
                                    };
                                    // Display default Mark component message, like QUICK_ACTIONS
                                    chatMsgs_1.push(componentMessage);
                                    setCachedMessages(componentMessage);
                                    // Display text message along with the Mark component
                                    if (textContent && textContent !== displayComponentName) {
                                        var chatMessage = {
                                            role: 'assistant',
                                            content: textContent,
                                            date: date_2,
                                            vote: VoteType.NONE,
                                        };
                                        // Display Text content Message
                                        chatMsgs_1.push(chatMessage);
                                        setCachedMessages(chatMessage);
                                    }
                                }
                                // Save functions response to prompts, so Penny can reference it later
                                if (assistantPromptMessage) {
                                    promptMsgs_1.push(assistantPromptMessage);
                                    setCachedPrompts(assistantPromptMessage);
                                }
                            });
                        }
                        setChatMessage(__spreadArray(__spreadArray([], chatMessages, true), chatMsgs_1, true));
                        setPrompts(__spreadArray(__spreadArray([], submitChatMessagesPayload.prompts, true), promptMsgs_1, true));
                        setLoadingStatus(false);
                    }
                    else if (!(result === null || result === void 0 ? void 0 : result.isOk)) {
                        if (typeof handleMarkerResponse === 'function') {
                            handleMarkerResponse(result, '');
                        }
                        analytics.log(__assign({ message: 'Failed to submit' }, result));
                        setErrorMessage((_f = result.errorMessage) !== null && _f !== void 0 ? _f : 'Network error! Please check your network connection and retry.');
                        setOpenErrorComponent(true);
                        setLoadingStatus(false);
                    }
                    return [2 /*return*/];
            }
        });
    });
};
//# sourceMappingURL=submitChatMessages.js.map